import { TableBody } from '@mui/material';
import { memo, useMemo } from 'react';
import { HeadCell } from './types';
import { PmiTableRow } from 'shell/components/shared/table/row';
import { PmiBodyTableCell } from 'shell/components/shared/table-custom/body';

interface TableBodyProps<T, K extends keyof T> {
  head: Array<HeadCell<T, K>>;
  body: Array<T>;
}

const TableBodyComponent = <T, K extends keyof T>({
  body = [],
  head,
}: TableBodyProps<T, K>): React.ReactElement => {
  const bodyJsx = useMemo(() => {
    return body.map((row, bodyItemIndex: number) => {
      const id = `table-row-${bodyItemIndex}`;

      return (
        <PmiTableRow key={id}>
          {head.map((column, headItemIndex) => {
            const labelId = `table-${row[column.id]}-${headItemIndex}`;
            if (column.label) {
              return (
                <PmiBodyTableCell
                  key={labelId}
                  id={labelId}
                  scope="row"
                  classes={{ root: 'notranslate' }}
                >
                  {row[column.id]}
                </PmiBodyTableCell>
              );
            }
            return null;
          })}
        </PmiTableRow>
      );
    });
  }, [body, head]);

  return <TableBody>{bodyJsx}</TableBody>;
};

TableBodyComponent.displayName = 'Table Body component';

const PmiTableBody = memo(TableBodyComponent);

export default PmiTableBody as unknown as typeof TableBodyComponent;
